import React, { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { createUser } from "../../redux/slices/userSlice";
import InputField from "../../components/InputField";
import { RegisterSchema } from "../../utilities/schemas";

const Register = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";
  const signinData = useSelector((state) => state?.userSignin);
  const { loading, userInfo } = signinData;

  const googleAuthHandler = () => {};

  const dispatch = useDispatch();

  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    agreement: "",
  };

  const registerHandler = (data) => {
    dispatch(
      createUser(data?.first_name, data?.last_name, data?.email, data?.password)
    );
  };

  useEffect(() => {
    if (userInfo) {
      navigate("/create-store");
    }
  }, [dispatch, navigate, redirect, userInfo]);

  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues,
    validationSchema: RegisterSchema,
    onSubmit: (data) => registerHandler(data),
    enableReinitialize: true,
  });

  return (
    <div className="container py-16">
      <div className="max-w-lg mx-auto shadow px-6 py-7 rounded overflow-hidden">
        <h2 className="text-2xl uppercase font-medium mb-1">
          Create an account
        </h2>
        <p className="text-gray-600 mb-6 text-sm">
          Sign up here if you're a new customer
        </p>
        <form>
          <div className="space-y-4">
            <div>
              <InputField
                label="First name"
                id="first_name"
                type="text"
                value={values.first_name}
                onChange={handleChange("first_name")}
                errorMsg={touched.first_name ? errors.first_name : undefined}
                placeholder="John"
              />
              <InputField
                label="Last name"
                id="last_name"
                type="text"
                value={values.last_name}
                onChange={handleChange("last_name")}
                errorMsg={touched.last_name ? errors.last_name : undefined}
                placeholder="Doe"
              />

              <InputField
                label="Email"
                id="email"
                type="email"
                value={values.email}
                onChange={handleChange("email")}
                errorMsg={touched.email ? errors.email : undefined}
                placeholder="Enter your email address"
              />
              <InputField
                label="Password"
                id="password"
                type="password"
                value={values.password}
                onChange={handleChange("password")}
                errorMsg={touched.password ? errors.password : undefined}
                placeholder="Enter your password"
              />
            </div>
          </div>
          <div>
            <div className="flex items-center justify-center mt-6">
              <InputField type="checkbox" id="agreement" />
              <span className="text-gray-600 ml-3 text-sm">
                I have read and agreed to the
              </span>
              &nbsp;
              <Link href="/#" className="text-primary text-sm">
                terms and conditions
              </Link>
            </div>
            <p className="text-red-500 text-xs">
              {touched.agreement ? errors.agreement : undefined}
            </p>
          </div>
          <div className="mt-4">
            <button
              onClick={handleSubmit}
              // onClick={navigate("/create-store")}
              className="block w-full py-2 text-center text-white bg-primary border border-primary rounded hover:bg-transparent hover:text-primary transition uppercase font-roboto font-medium"
            >
              create account
            </button>
          </div>
        </form>
        <div className="flex mt-6 justify-center relative">
          <div className="text-gray-600 uppercase px-3 bg-white z-10 relative">
            or sign up with
          </div>
          <div className="absolute left-0 top-3 w-full border-b-2 border-gray-200"></div>
        </div>
        <div className="flex mt-4 gap-4">
          <a
            href="/"
            onClick={googleAuthHandler}
            className="w-1/2 py-2 text-center text-white bg-yellow-600 hover:bg-yellow-500 rounded uppercase font-roboto font-medium text-sm"
          >
            Google
          </a>
        </div>
        <p className="mt-4 text-gray-600 text-center">
          Already have an account?
          <span className="text-primary cursor-pointer">
            <Link to="/login?redirect=/create-store"> Create a store</Link>
          </span>
          <span> or</span>
          <span className="text-primary cursor-pointer">
            <Link to={`/login?redirect=${redirect}`}> Login Now</Link>
          </span>
        </p>
      </div>
    </div>
  );
};
export default Register;
